import type { IntlShape } from 'react-intl';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import type { User } from '@alltrails/types/User';
import footerLinks, { FooterLinksType } from '../generateFooterLinks';
import styles from './styles.module.scss';
import MobileLinks from './MobileLinks';
import DesktopLinks from './DesktopLinks';

type Props = {
  intl: IntlShape;
  languageRegionCode: LanguageRegionCode;
  user?: User | null;
  irclickid?: string;
};

const FooterLinks = ({ intl, languageRegionCode, user, irclickid }: Props) => {
  const linkData = footerLinks({ intl, languageRegionCode, user, irclickid });

  return (
    <nav className={styles.nav}>
      <div className={styles.expandableContainer}>
        {linkData.map((link: FooterLinksType) => (
          <MobileLinks
            amplitudeEventName={link.amplitudeEventName}
            key={link.title}
            href={link.href}
            childLinks={link.childLinks}
            title={link.title}
            testId={link.testId}
          />
        ))}
      </div>
      <div className={styles.footerLinksContainer}>
        {linkData.map((link: FooterLinksType) => (
          <DesktopLinks
            amplitudeEventName={link.amplitudeEventName}
            key={link.title}
            href={link.href}
            childLinks={link.childLinks}
            title={link.title}
            testId={link.testId}
          />
        ))}
      </div>
    </nav>
  );
};

export default FooterLinks;
